import Tooltip from "components/Tooltip/Tooltip";
import React, { useEffect, useMemo, useState } from 'react'
import { FaCheck } from 'react-icons/fa';
import { MdRemoveCircle } from 'react-icons/md';
import fetchData from 'utils/fetchData';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import stringUtilities from "utils/stringUtilities";

export default function SubmittedScores() {
    const [result, setResult] = useState();
    const [interviewerFilter, setInterviewerFilter] = useState();
    const [jobPositionFilter, setJobPositionFilter] = useState();
    const [applicantFilter, setApplicantFilter] = useState();
    const MySwal = withReactContent(Swal);
    useEffect(() => {
        GetData();
    }, []);

    const GetData = async () => {
        try {
            var pResult = await fetchData.Post('/api/hrmpsb/SubmittedScores', {});
            setResult(pResult);
            // uncheckAll();
        } catch (e) {
            console.log(e);
        }
    };

    function toogleCheck(vInterviewID, vJobPositionID, vApplicanID) {
        setResult(prevState =>
            prevState.map(vInterviewer => {
                if (vInterviewer.interviewerID == vInterviewID)
                    vInterviewer.jobPositions.map(vJobPosition => {
                        if (vJobPosition.jobPositionID == vJobPositionID)
                            vJobPosition.applicants.map(vApplicant => {
                                if (vApplicant.applicantID == vApplicanID) {
                                    vApplicant.selected = !vApplicant.selected;
                                }
                                return vApplicant;
                            });
                        return vJobPosition;
                    })
                return vInterviewer;
            })
        );
    }

    async function unsubmit() {
        var pSelected = getChecked();
        if (pSelected.length == 0) {
            MySwal.fire({
                title: "Error",
                text: 'Please select at 1 row to return.',
                icon: "warning"
            });
            return;
        }
        var pResult = await MySwal.fire({
            title: "Are you sure?",
            text: "Return selected scores?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        });
        if (!pResult.isConfirmed)
            return;
        try {
            var pResult = await fetchData.Post('/api/hrmpsb/UnsubmitScores', pSelected);
            await MySwal.fire({
                title: "Success",
                text: "The selected scores were successfully return.",
                icon: "info"
            });
            await GetData();
        } catch (e) {
            MySwal.fire({
                title: "Error",
                text: e,
                icon: "error"
            });
        }
    }

    function getChecked() {
        var pOut = [];
        result.map(vInterviewer => {
            vInterviewer.jobPositions.map(vJobPosition => {
                vJobPosition.applicants.map(vApplicant => {
                    if (vApplicant.selected)
                        pOut.push({
                            interviewerID: vInterviewer.interviewerID,
                            jobPositionID: vJobPosition.jobPositionID,
                            applicantID: vApplicant.applicantID
                        });
                    return vApplicant;
                });
                return vJobPosition;
            });
            return vInterviewer;
        });
        return pOut;
    }

    const filteredResult = useMemo(() => {
    const list = Array.isArray(result) ? result : [];

    const iFilter = (interviewerFilter ?? '').toLowerCase();
    const jpFilter = (jobPositionFilter ?? '').toLowerCase();
    const apFilter = (applicantFilter ?? '').toLowerCase();

    return list
        .map(interviewer => {
        const jobPositions = (interviewer.jobPositions ?? [])
            .map(jp => {
            const applicants = (jp.applicants ?? []).filter(a =>
                (a.applicantName ?? '').toLowerCase().includes(apFilter)
            );

            const jpMatches = (jp.jobPositionName ?? '').toLowerCase().includes(jpFilter);
            const keepJP = jpMatches; // || applicants.length > 0;

            return keepJP ? { ...jp, applicants } : null;
            })
            .filter(Boolean);

        const interviewerMatches =
            (interviewer.interviewerName ?? '').toLowerCase().includes(iFilter);
        const keepInterviewer = interviewerMatches; // || jobPositions.length > 0;

        return keepInterviewer ? { ...interviewer, jobPositions } : null;
        })
        .filter(Boolean);
    }, [result, interviewerFilter, jobPositionFilter, applicantFilter]);


    function uncheckAll(vCheck) {
        vCheck = stringUtilities.CBool(vCheck);
        setResult(prevState =>
            prevState.map(vInterviewer => {
                vInterviewer.jobPositions.map(vJobPosition => {
                    vJobPosition.applicants.map(vApplicant => {
                        vApplicant.selected = vCheck;
                        return vApplicant;
                    });
                    return vJobPosition;
                })
                return vInterviewer;
            })
        );
    }

    return (
        <div>
            <div className="flex items-center justify-between my-2 px-2 sticky xz-50 bg-white">
                <div className="flex items-center gap-3"></div>
                <div className="flex items-center gap-3">
                    <button
                        className={`flex self-center`}
                        onClick={unsubmit}
                    >
                        <Tooltip text="Return selected scores">
                            <MdRemoveCircle className="text-red-600 w-6 h-6" />
                        </Tooltip>
                    </button>
                </div>
                
            </div>
            <div className="grid grid-cols-1 md:grid-cols-12 py-0 gap-4 ">
                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Filter by interviewer
                    </label>
                    <input
                        type="text"
                        //  id="username"
                        value={interviewerFilter}
                        onChange={e => setInterviewerFilter(e.target.value)}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>
                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Filter by job position
                    </label>
                    <input
                        type="text"
                        //  id="username"
                        value={jobPositionFilter}
                        onChange={e => setJobPositionFilter(e.target.value)}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>
                <div className="col-span-1 md:col-span-4">
                    <label className="labels">
                        Filter by applicant
                    </label>
                    <input
                        type="text"
                        //  id="username"
                        value={applicantFilter}
                        onChange={e => setApplicantFilter(e.target.value)}
                        className="inputs"
                        autoComplete="off"
                    />
                </div>
            </div>
            <table className="mt-4 border w-full max-h-[65vh] relative">
                <thead>
                    <tr className="bg-primary">
                        <th className="border-r w-[30px] ">
                            <input
                                type="checkbox"
                                name="checkbox"
                            />
                        </th>
                        <th className="text-center text-white p-2 border sticky top-0">Applicant</th>
                        <th className="text-center text-white p-2 border sticky top-0">SM</th>
                        <th className="text-center text-white p-2 border sticky top-0">BI</th>
                        <th className="text-center text-white p-2 border sticky top-0">BEI</th>
                        <th className="text-center text-white p-2 border sticky top-0">PSA</th>
                    </tr>
                </thead>

                <tbody>
                    {filteredResult?.map(vInterviewer => {
                        return <>
                            <tr className="bg-primary">
                                <th className="border-r  ">
                                    <input
                                        type="checkbox"
                                        name="checkbox"
                                    />
                                </th>
                                <th colspan="5" className="text-white p-2 border text-center">Interviewer: {vInterviewer.interviewerName}</th>
                            </tr>
                            {vInterviewer.jobPositions.map(vJobPosition => {
                                return <>
                                    <tr className='bg-secondary'>
                                        <th className="border-r  ">
                                            <input
                                                type="checkbox"
                                                name="checkbox"
                                            />
                                        </th>
                                        <th colspan="5" className="p-2 border text-center">Job Position: {vJobPosition.jobPositionName}</th>
                                    </tr>
                                    {vJobPosition.applicants.map(vApplicant => {
                                        return <tr>
                                            <th className="border-r  ">
                                                <input
                                                    type="checkbox"
                                                    name="checkbox"
                                                    checked={vApplicant.selected}
                                                    onChange={() => toogleCheck(vInterviewer.interviewerID, vJobPosition.jobPositionID, vApplicant.applicantID)}
                                                />
                                            </th>
                                            <td className="p-2 border text-center">
                                                {vApplicant.applicantName}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.SM === true && <FaCheck className='m-auto' />}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.BI === true && <FaCheck className='m-auto' />}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.BEI === true && <FaCheck className='m-auto' />}
                                            </td>
                                            <td className="p-2 border text-center">
                                                {vApplicant.categories.PSA === true && <FaCheck className='m-auto' />}
                                            </td>
                                        </tr>
                                    }) /* vJobPosition.applicants.map */}
                                </>
                            }) /* vInterviewer.jobPositions.map */}
                        </>
                    }) /* result?.map(vInterviewer */}
                </tbody>
            </table>
        </div>
    )
}
